import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Tooltip } from '@material-ui/core';
import Button from "components/CustomButtons/Button.js";
import { CloudUpload } from '@material-ui/icons';

export default function FileUploadDialog({ open, onClose, newFile = {}, setNewFile, onSave, replace, file_type }) {
    const handleFileChange = (event) => {
        const fileList = Array.from(event.target.files || []);
        if (!fileList.length) return;
        if (file_type === 'multifile') {
            setNewFile({
                files: fileList,
                file: fileList,
                // Auto metadata summary (not used directly for each upload; computed later)
                name: `Batch upload (${fileList.length} files)`,
                description: `Batch upload of ${fileList.length} files on ${new Date().toLocaleDateString()}`,
            });
        } else {
            const file = fileList[0];
            setNewFile({
                file,
                files: [file],
                name: file.name,
                description: `${file.name} uploaded on ${new Date().toLocaleDateString()}`,
            });
        }
    };

    const getFileFormats = (type) => {
        switch (type) {
            case "multifile":
                return {
                    acceptableFormats: ".pdf",
                    fileAccept: ".pdf",
                };
            case "file":
                return {
                    // acceptableFormats: ".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .csv, .txt",
                    // fileAccept: ".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.csv,.txt",
                    acceptableFormats: ".pdf",
                    fileAccept: ".pdf",
                };
            case "image":
                return {
                    acceptableFormats: ".jpg, .jpeg, .png",
                    fileAccept: ".jpg,.jpeg,.png",
                };
            case "powerpoint_presentations":
                return {
                    acceptableFormats: ".ppt, .pptx",
                    fileAccept: ".ppt,.pptx",
                };
            case "video":
                return {
                    acceptableFormats: ".mp4, .avi, .mkv, .mov, .wmv",
                    fileAccept: ".mp4,.avi,.mkv,.mov,.wmv",
                };
            case "dataset":
                return {
                    acceptableFormats: ".csv, .xls, .xlsx",
                    fileAccept: ".csv,.xls,.xlsx",
                };
            default:
                return {
                    acceptableFormats: "",
                    fileAccept: "",
                };
        }
    };

    const { acceptableFormats, fileAccept } = getFileFormats(file_type);

   


    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <Typography variant="h6" style={{ textTransform: 'none' }}>
                    {replace ? 'Replace File(s)' : 'Upload Resource File(s)'}
                </Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
                    Select {file_type === 'multifile' ? 'multiple files' : 'a file'}; names & descriptions will be auto-assigned.
                </Typography>
                <Button
                    variant="contained"
                    component="label"
                    color="quCreateColor"
                >
                    <CloudUpload />
                    {replace ? "Replace" : file_type === 'multifile' ? 'Upload Files' : 'Upload File'}
                    <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        multiple={file_type === 'multifile'}
                        onChange={handleFileChange}
                    />
                </Button>
                {/* Display selected files */}
                {Array.isArray(newFile?.files) && newFile.files.length > 0 && (
                    <div style={{ marginTop: 8 }}>
                        <Typography variant="body2" style={{ fontWeight: 600 }}>
                            {newFile.files.length === 1 ? 'Selected File:' : 'Selected Files:'}
                        </Typography>
                        <ul style={{ margin: '4px 0 0', paddingLeft: 18, maxHeight: 180, overflowY: 'auto' }}>
                            {newFile.files.map((f, idx) => (
                                <li key={idx} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {f.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <Typography
                    variant="caption"
                    color="textSecondary"
                    style={{ marginTop: '8px', display: 'block' }}
                >
                    Acceptable formats: {acceptableFormats}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="quCreateColor">Cancel</Button>
                <Button
                    onClick={onSave}
                    color="quCreateColor"
                    disabled={!(newFile.file || (Array.isArray(newFile.files) && newFile.files.length))}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
